import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavController, ModalController, NavParams } from '@ionic/angular';
import { ConfigService } from 'src/providers/config/config.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { LoadingService } from 'src/providers/loading/loading.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Storage } from '@ionic/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import { LoginPage } from '../modals/login/login.page';
import { AppEventsService } from 'src/providers/app-events/app-events.service';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { CurencyPipe } from 'src/pipes/curency.pipe';

@Component({
  selector: 'app-product-auction',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './product-auction.page.html',
  styleUrls: ['./product-auction.page.scss'],
  providers: [CurencyPipe]
})
export class ProductAuctionPage implements OnInit {

  public product;

  attributes = [];
  selectAttribute = true;
  discount_price;
  flash_price;
  product_price;
  price_buy;
  cartButton = "addToCart";
  is_upcomming = false;
  is_bid = false;

  public isLiked = 0;
  public wishArray = [];
  public disableCartButton = false;
  public variations = new Array;
  public groupProducts = new Array;
  public variationPrice = null;
  public loaderWcVendorInfo = false;
  public wcVendorInfo: any;
  public loaderProductVariations = false;
  public bid_amount = '';


  pId: any;
  sliderConfigReleatedItems = {
    slidesPerView: this.config.productSlidesPerPage,
    spaceBetween: 0
  }
  sliderConfig = {
    zoom: true
  }

  ratingStarsValue = 1;

  numberMask = createNumberMask({ prefix: ' ', thousandsSeparatorSymbol: '.', allowDecimal: true, decimalSymbol: ',' });

  constructor(
    public navCtrl: NavController,
    public config: ConfigService,
    public shared: SharedDataService,
    public modalCtrl: ModalController,
    public loading: LoadingService,
    public iab: InAppBrowser,
    public appEventsService: AppEventsService,
    private photoViewer: PhotoViewer,
    private socialSharing: SocialSharing,
    public curencyPipe: CurencyPipe,
    public navParams: NavParams,
    private mdCtrl: ModalController) {

    //this.pId = this.activatedRoute.snapshot.paramMap.get('id');
    this.pId = navParams.get('product_id');
    console.log('producto: ' + this.pId);
    this.product = JSON.parse(JSON.stringify(this.getProductData(this.pId)));
    this.discount_price = this.product.discount_price;
    this.product_price = this.product.products_price;
    this.flash_price = this.product.flash_price;
    if (this.product.products_type == 0 && this.product.defaultStock <= 0) this.cartButton = "outOfStock";
    if (this.product.products_type == 1) this.cartButton = "addToCart";
    if (this.product.products_type == 2) this.cartButton = "external";

    this.price_buy = this.getPriceBuy();

    if (this.product.attributes != null && this.product.attributes != undefined && this.product.attributes.length != 0) {
      //this.selectAttribute = this.product.attributes[0].values[0];
      this.product.attributes.forEach((value, index) => {

        var att = {
          products_options_id: value.option.id,
          products_options: value.option.name,
          products_options_values_id: value.values[0].id,
          options_values_price: value.values[0].price,
          price_prefix: value.values[0].price_prefix,
          products_options_values: value.values[0].value,
          attribute_id: value.values[0].products_attributes_id,
          name: value.values[0].value + ' ' + value.values[0].price_prefix + value.values[0].price + " " + this.config.currency
        };
        value.name = value.values[0];
        this.attributes.push(att);
      });
      this.checkAvailability();
      //  console.log(this.attributes);
    }
  }

  getPriceBuy() {
    let p = this.curencyPipe.transform(this.product_price);
    return p;
  }


  CheckBidNow() {
    let seguir = true;
    let mensaje = '';
    let amount = this.bid_amount.replace('.', '');
    let higher_bid = this.product.higher_bid;


    amount = amount.replace('.', '');
    amount = amount.replace('.', '');
    amount = amount.replace('.', '');
    amount = amount.replace(',', '.');


    //higher_bid = higher_bid.replace('.', '');
    //higher_bid = higher_bid.replace('.', '');
    //higher_bid = higher_bid.replace('.', '');
    //higher_bid = higher_bid.replace(',', '.');
    console.log(higher_bid);
    console.log(amount);
    console.log(this.product.starting_price);
    if (this.product.starting_price > amount) {
      seguir = false;
      mensaje = 'Debe superar al precio inicial...';
    } else {

      if (higher_bid > amount) {
        seguir = false;
        mensaje = 'Debe superar a la oferta actual...';
      } else {


        if ((parseFloat(amount) - parseFloat(higher_bid)) < 5000) {
          seguir = false;
          mensaje = 'Debe superar a la oferta actual por lo menos en 5.000 Guaranies';

        }
      }
    }

    if (seguir == true) {
      this.clickBidNow();
    } else {

      this.shared.showAlertWithTitle(mensaje, 'Oferta');
    }

  }

  async clickBidNow() {

    if (this.shared.customerData.customers_id == null || this.shared.customerData.customers_id == undefined) {
      let modal = await this.modalCtrl.create({
        component: LoginPage,
        componentProps: {
          'hideGuestLogin': true
        }
      });
      await modal.present();
    }
    else {
      this.doBidNow();
    }
  }


  doBidNow() {


    // eliminar los puntos de millares. y poner el punto decimal en vez de ,


    // ofertar...
    var dat: { [k: string]: any } = {};
    dat.customers_id = this.shared.customerData.customers_id;
    dat.languages_id = this.config.langId;
    dat.currency_code = this.config.currecnyCode;
    dat.bid_amount = this.bid_amount;
    dat.auction_id = this.product.auction_id;

    console.log(this.shared.customerData);
    if ((this.shared.customerData.customers_telephone == null || this.shared.customerData.customers_telephone == undefined
      || this.shared.customerData.customers_telephone == '' || this.shared.customerData.document == '')
    ) {
      this.shared.showAlert('Debe completar su perfil para poder ofertar.');
      this.dismiss();
    } else {
      this.loading.show();
      this.is_bid = true;
      this.config.post_Http('addauctionbid', dat)
        .subscribe(
          (data) => { // Success
            this.loading.hide();
            if (data["resultado"]["estado"] == 1) {
              this.loading.hide();
              // refrescar la pantalla.

              this.dismiss();
              // recargar la pantalla.. o salir
              //this.navCtrl.pop();
            }
          },
          (error) => {
            this.loading.hide();
            console.error(error);
          });
    }
  }

  zoomImage(img) {
    this.photoViewer.show(img);
  }
  getProductData(id) {
    let p;
    console.log(this.shared.singleProductPageData);

    this.shared.singleProductPageData.forEach(element => {
      if (element.products_id == id) {
        p = element;
      }
    });
    return p;
  }
  checkAvailability() {
    this.loading.show();
    let att = [];
    for (let a of this.attributes) {
      att.push(a.attribute_id.toString());
    }

    let data = {
      products_id: this.product.products_id.toString(),
      attributes: att
    };


    this.config.post_Http('getquantity', data)
      .subscribe(
        (data) => { // Success        
          this.loading.hide();
          if (data['resultado'].estado == 1) {
            if (data['resultado'].stock > 0) {
              this.cartButton = "addToCart"
            }
            else {
              this.cartButton = "outOfStock"
              this.shared.toast("Product Not Available With these Attributes!");
            }

          }
        }, error => {
          this.loading.hide();
        });


  }
  openProductUrl() {
    this.loading.autoHide(2000);
    this.iab.create(this.product.products_url, "blank");
  }
  addToCartProduct() {
    this.loading.autoHide(500);
    this.product.price = this.product.products_price;
    console.log(this.product);
    this.shared.addToCart(this.product, this.attributes);
    this.navCtrl.pop();
  }

  //============================================================================================  
  //function adding attibute into array
  fillAttributes = function (val, optionID) {

    //console.log(val);
    //  console.log(this.attributes);
    this.attributes.forEach((value, index) => {
      if (optionID == value.products_options_id) {
        value.products_options_values_id = val.id;
        value.options_values_price = val.price;
        value.price_prefix = val.price_prefix;
        value.attribute_id = val.products_attributes_id;
        value.products_options_values = val.value;
        value.name = val.value + ' ' + val.price_prefix + val.price + " " + this.config.currency
      }
    });
    //  console.log(this.attributes);
    //calculating total price 
    this.calculatingTotalPrice();
    //  this.checkAvailability();
  };
  //============================================================================================  
  //calculating total price  
  calculatingTotalPrice = function () {
    var price = parseFloat(this.product.products_price.toString());
    if (this.product.discount_price != null || this.product.discount_price != undefined)
      price = this.product.discount_price;
    var totalPrice = this.shared.calculateFinalPriceService(this.attributes) + parseFloat(price.toString());

    if (this.product.discount_price != null || this.product.discount_price != undefined)
      this.discount_price = totalPrice;
    else
      this.product_price = totalPrice;
    //  console.log(totalPrice);
  };

  checkProductNew() {
    //  var pDate = new Date(this.product.products_date_added);
    //  var date = pDate.getTime() + this.config.newProductDuration * 86400000;
    //   var todayDate = new Date().getTime();
    //    if (date > todayDate)
    if (this.product.codigo.substr(0, 1) == 'N')
      return true;
    else
      return false
  }


  checkPrice_Buy() {
    return (this.product_price > 0)
  }


  pDiscount() {
    var rtn = "";
    var p1 = parseInt(this.product.products_price);
    var p2 = parseInt(this.product.discount_price);
    if (p1 == 0 || p2 == null || p2 == undefined || p2 == 0) { rtn = ""; }
    var result = Math.abs((p1 - p2) / p1 * 100);
    result = parseInt(result.toString());
    if (result == 0) { rtn = "" }
    rtn = result + '%';
    return rtn;
  }
  share() {
    this.loading.autoHide(1000);
    // Share via email
    this.socialSharing.share(
      this.product.products_name,
      this.product.products_name,
      this.config.url + this.product.products_image,
      this.product.products_url).then(() => {
        // Success!
      }).catch(() => {
        // Error!
      });

  }
  async clickWishList() {

    if (this.shared.customerData.customers_id == null || this.shared.customerData.customers_id == undefined) {
      let modal = await this.modalCtrl.create({
        component: LoginPage,
        componentProps: {
          'hideGuestLogin': true
        }
      });
      return await modal.present();
    }
    else {
      if (this.product.isLiked == '0') { this.addWishList(); }
      else this.removeWishList();
    }
  }
  addWishList() {
    this.shared.addWishList(this.product);
  }
  removeWishList() {
    this.shared.removeWishList(this.product);
  }

  //===============================================================================================================================
  // <!-- 2.0 updates -->
  openReviewsPage() {
    this.navCtrl.navigateForward("/reviews/" + this.product.id);
  }

  ratingPercentage() {
    return this.shared.getProductRatingPercentage(this.product.rating);
  }

  ngOnInit() {
    if (this.product.flash_start_date) {
      if (this.product.server_time < this.product.flash_start_date) this.is_upcomming = true;
      console.log("server time less than " + (this.product.server_time - this.product.flash_start_date));
    }
  }


  //===============================================================================================================================
  // getProductReviews() {
  //   this.config.getHttp("getreviews?languages_id=" + this.config.langId + "&products_id=" + this.product.id).then((data: any) => {
  //     this.product.reviewed_customers = data.data
  //   });
  // }

  ionViewWillEnter() {
    // this.getProductReviews();
  }



  dismiss() {

    this.mdCtrl.dismiss();
  }


}
